import { Box } from '@collinsonx/design-system/core';
import useLocale from 'hooks/useLocale';

function LoungeClosedMessage() {
  const translations = useLocale();
  const messageDescription =
    translations.lounge.errors.loungeClosed.description;

  return <Box>{messageDescription}</Box>;
}

export default LoungeClosedMessage;
